import { useSelector } from "react-redux";
import { getResponsiblesState } from "../../selectors/responsiblesSelectors";
import { useUserIdState } from "../../selectors/userInfoSelectors";
import responsibleHelper from "../../utils/helpers/responsibleHelper";

const useDefaultResponsibleFilter = (defaultResponsibleAmount: number): string[] => {
  const userId = useUserIdState();
  if (defaultResponsibleAmount <= 1) return [userId];

  const sortedByNicknameResponsibleIds = useSelector(getResponsiblesState)
    .filter(({ id }: { id: string }) => id !== userId)
    .sort(responsibleHelper.sortResposibleArrayByNickname)
    .map(({ id }: { id: string }) => id);

  const slicedResponsibleIdListWithoutUser = sortedByNicknameResponsibleIds.slice(
    0,
    defaultResponsibleAmount - 1
  );

  return [userId, ...slicedResponsibleIdListWithoutUser];
};

export default useDefaultResponsibleFilter;
